import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialPersonnelsApi = {
    getTrialPersonnelById: (id: number): Observable<Dtos.GetTrialPersonnelByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelById = new Dtos.GetTrialPersonnelById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialPersonnelsByPersonnelId: (personnelId: number): Observable<Dtos.GetTrialPersonnelsByPersonnelIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelsByPersonnelId = new Dtos.GetTrialPersonnelsByPersonnelId();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelsByPersonnelIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialPersonnelsByTrialId: (trialId: number, groupLevelTypeId: number | null): Observable<Dtos.GetTrialPersonnelsByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelsByTrialId = new Dtos.GetTrialPersonnelsByTrialId();

        request.trialId = trialId;
        request.groupLevelTypeId = groupLevelTypeId;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelsByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialPersonnelsByInstitutionId: (institutionId: number, groupLevelTypeId: number | null): Observable<Dtos.GetTrialPersonnelsByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelsByInstitutionId = new Dtos.GetTrialPersonnelsByInstitutionId();

        request.institutionId = institutionId;
        request.groupLevelTypeId = groupLevelTypeId;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelsByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialPersonnelsByTrialInstitutionId: (trialInstitutionId: number, groupLevelTypeId: number | null): Observable<Dtos.GetTrialPersonnelsByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelsByTrialInstitutionId = new Dtos.GetTrialPersonnelsByTrialInstitutionId();

        request.trialInstitutionId = trialInstitutionId;
        request.groupLevelTypeId = groupLevelTypeId;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelsByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialPersonnelsByTrialGroupId: (trialGroupId: number, groupLevelTypeId: number | null): Observable<Dtos.GetTrialPersonnelsByTrialGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelsByTrialGroupId = new Dtos.GetTrialPersonnelsByTrialGroupId();

        request.trialGroupId = trialGroupId;
        request.groupLevelTypeId = groupLevelTypeId;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelsByTrialGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialPersonnelsByGroupId: (groupId: number, groupLevelTypeId: number): Observable<Dtos.GetTrialPersonnelsByGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialPersonnelsByGroupId = new Dtos.GetTrialPersonnelsByGroupId();

        request.groupId = groupId;
        request.groupLevelTypeId = groupLevelTypeId;

        //Send request.
        const response: Promise<Dtos.GetTrialPersonnelsByGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialPersonnel: (trialPersonnel: Dtos.TrialPersonnel): Observable<Dtos.SetTrialPersonnelResponse> => {

        let request: Dtos.SetTrialPersonnel = new Dtos.SetTrialPersonnel();

        request.trialPersonnel = trialPersonnel;

        // send request
        const response: Promise<Dtos.SetTrialPersonnelResponse> = client.post(request);

        return Observable.from(response);

    },
    createTrialPersonnel: (trialId: number | null, institutionId: number | null, groupId: number | null): Observable<Dtos.CreateTrialPersonnelResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialPersonnel = new Dtos.CreateTrialPersonnel();

        request.trialId = trialId;
        request.institutionId = institutionId;
        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.CreateTrialPersonnelResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialPersonnel: (trialPersonnel: Dtos.TrialPersonnel): Observable<Dtos.ValidateTrialPersonnelResponse> => {

        let request: Dtos.ValidateTrialPersonnel = new Dtos.ValidateTrialPersonnel();

        request.trialPersonnel = trialPersonnel;

        // send request
        const response: Promise<Dtos.ValidateTrialPersonnelResponse> = client.post(request);

        return Observable.from(response);

    }
}